import './event-details-modal.style.sass';
import template from './event-details-modal.tpl.pug';

class EventDetailsController {
    dismiss() {
        return this.onDismiss();
    }

    close() {
        return this.onClose({
            data: this.event
        });
    }
}

export default {
    selector: 'dbAEventDetailsModal',
    template: template(),
    controller: EventDetailsController,
    bindings: {
        event: '<',

        canEdit: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-details-modal/event-details-modal.cmpt.js